<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">优tech分享｜强化人脸安全，腾讯优图提出深度伪造溯源新基准</div>
      <div class="news-date">2023年10月20日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          AIGC技术的快速发展使得现实场景出现了大量新型的伪造图像，引发了公众对AI内容安全的担忧。为应对这些挑战，腾讯优图实验室构建了一个“开放场景下深度伪造溯源”（OpenWorld-DeepFake Attribution，OW-DFA）新基准，涵盖人脸替换、表情驱动、属性编辑、全脸生成等近20种主流伪造技术，以评估开放场景下不同伪造人脸类型的溯源性能，促进深度伪造溯源任务的可解释性和安全性，并强化深度伪造检测能力。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news44.png"/>
          </div>
        </div>
        <div class="download-article-wrap">
          <div class="download-article">
            <span class="mark-text">论文链接：</span>
            <a href="https://arxiv.org/abs/2309.11132" target="_blank">https://arxiv.org/abs/2309.11132</a>
          </div>
          <div class="download-article">
            <span class="mark-text">代码链接：</span>
            <a href="https://github.com/TencentYoutuResearch/OpenWorld-DeepFakeAttribution" target="_blank" >https://github.com/TencentYoutuResearch/OpenWorld-DeepFakeAttribution</a>
          </div>
        </div>
        <br>

        <div class="news-content-mark">
          <h2>01 背景和挑战</h2>
        </div>
        <p>
          随着生成技术的快速发展，对于深度伪造人脸的攻击类型溯源问题已经引起了广泛关注。现有的诸多研究在GAN溯源任务上有一些进展，但忽略了更具威胁性的人脸替换或表情驱动等攻击类型。此外，开放场景下往往存在着大量的新型攻击手法，如何进行准确发现也具有较大挑战。腾讯优图实验室针对性构建了一个
          <span class="mark-text highlight">“开放场景下深度伪造溯源”（OpenWorld-DeepFake Attribution，OW-DFA）</span>
          新基准，涵盖了人脸替换、表情驱动、属性编辑、全脸生成等近20种主流伪造技术，同时设置无标注的攻击数据模拟开放场景。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/technology/news44/news44_1.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <h2>02 解决思路</h2>
        </div>
        <p>
          针对OW-DFA任务，腾讯优图实验室提出对比式伪标签学习（Contrastive Pseudo Learning，CPL）。CPL是一种面向开放场景的半监督学习方法，同时在有标注数据和无标注数据进行对比学习和伪标签学习，从而来增强模型在已知和未知人脸攻击上的溯源能力和鲁棒性。相比于传统的半监督学习方法，CPL方法具有更高的效率和更好的性能，在OW-DFA任务中取得了较好的表现。该算法包括以下部分：
        </p>
        <p>
          <span class="mark-text highlight">· 全局局部投票（GLV）模块：</span>
          针对对比学习中样本对的选择问题，设计全局局部投票模块。首先对每个样本对提取全局和局部特征信息，并对局部特征自适应地通过“空间增强机制”突出不同的伪造区域，从而获得不同样本间的局部相似度。通过结合全局和局部相似性，更准确地将同一攻击类型的样本聚类。<br />
          <span class="mark-text highlight">· 基于置信度的软伪标签（CSP）模块：</span>
          针对无标注样本缺少标签的问题，设计基于置信度的软伪标签模块。该模块首先使用Gumbel-Softmax获得每个样本的伪标签，并基于该样本输出的概率对于伪标签分配权重，从而减轻相似的新型攻击方法引起的伪噪声。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/technology/news44/news44_2.png"/>
          </div>
        </div>
        <p>
          为了进一步提高在OW-DFA上的溯源性能，腾讯优图将自研CPL算法与广泛使用的预训练和迭代学习技术结合在一起，提出了一个新型的
          <span class="mark-text highlight">多阶段范式算法</span>
          ，包括预训练、半监督学习和迭代学习三个阶段。通过这种多阶段训练范式，在OW-DFA任务中取得了更好的人脸伪造溯源性能：
        </p>
        <p>
          <span class="mark-text highlight">· 预训练阶段：</span>
          在有标签数据上直接进行有监督学习，让模型在已知攻击上获得初始稳定的溯源性能。<br />
          <span class="mark-text highlight">· 半监督学习阶段：</span>
          加载预训练阶段得到的模型权重，然后基于自研CPL算法在有标签和无标签数据上进行训练，可以让模型同时在已知攻击和未知攻击上都具有较好的鉴别性。<br />
          <span class="mark-text highlight">· 迭代学习阶段：</span>
          加载半监督学习阶段得到的模型权重，然后使用Semi-Sup K-Means算法获得无标签数据的高质量伪标签，并与有标签数据结合在一起来微调模型，以进一步提高模型的鲁棒性和性能。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/technology/news44/news44_3.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <h2>03 实验结果</h2>
        </div>
        <p>
          实验结果证明了所提出的CPL方法在OW-DFA基准测试上的优越性。对比现有的GAN溯源领域的方法（DNA-Det、Openworld-GAN），以及开放场景下半监督学习的方法（ORCA、NACH等），本文方法在新型攻击以及整体拦截效果上均有显著提升，证明了CPL方法可有效应用于开放场景下的深伪溯源任务。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/technology/news44/news44_4.png"/>
          </div>
        </div>
        <p>
          为了进一步探究深度伪造溯源与深度伪造检测两个任务间的关联，本文模拟真实场景针对性构建真假分类的实验。当获取到一批新型攻击数据时，其中分别包含已知伪造人脸、未知伪造人脸、未知真实人脸，基于二分类和多分类的深伪检测模型虽然在已知伪造人脸上取得良好的性能，但是在未知数据上缺乏泛化性。相比之下，本文提出的CPL方法可有效利用开放场景的数据进行半监督训练，在已知和未知数据上的真假检测AUC结果均远超二分类与多分类模型，表明深度伪造溯源任务能够有效促进深度伪造检测的发展。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/technology/news44/news44_5.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <h2>04 技术应用</h2>
        </div>
        <p>
          在人脸安全应用场景，腾讯优图研发了相应的内容取证技术框架，结合局部特征差异、噪声模式以及时序信息、可有效防御人脸替换、表情驱动等主流合成攻击，并支持MidJourney和Stable Diffusion等新型生成技术的鉴别。同时基于CPL溯源技术，支持近百种攻击的伪造类型溯源，有效增强人脸安全。
        </p>
        <p>
          人脸应用安全是当今智能时代的重要命题，为防范AI技术滥用，腾讯优图实验室未来将在人脸安全领域持续深耕，精心打磨算法研究和业务落地，不断开放和输出相关技术服务，更好地保障相关应用的安全。同时，腾讯优图实验室也将继续坚持科技向善的理念，推进社会价值可持续创新，从而让AI更好地为社会服务。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News44',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News44.vue